import { Inject, Injectable } from '@angular/core';
import { GEOMETRIC_FORM_SERVICE } from 'src/app/geometrics-form/geometric-form.module';
import { GeometricFormService } from 'src/app/geometrics-form/state/geometric-form.service';
import { MapDrawService } from 'src/app/shared/components/map/map-draw.service';
import { MapAction } from '../actions/map-action';
import { MenuEventService } from '../actions/map-actions/menu-event.service';
import { ProjectDemographicAreasService } from './project-demographic-areas.service';

@Injectable({
  providedIn: 'root'
})
export class LayerService {

  mapActions: MapAction[] = [];

  constructor(
    menuEventService: MenuEventService,
    @Inject(GEOMETRIC_FORM_SERVICE)
    private geometricServices: GeometricFormService<any>[],
    private drawService: MapDrawService,
    private demographicAreasComponent: ProjectDemographicAreasService
  ) {
    this.mapActions.push(menuEventService);
  }

  enableActions() {
    this.mapActions.forEach(a => a.active = true);
  }

  disableActions() {
    this.mapActions.forEach(a => a.active = false);
  }

  hide() {
    this.drawService.clear();
    this.geometricServices.forEach(s => s.updateUI({ visible: false }));
    this.demographicAreasComponent.clearLayers();
  }

  show() {
    this.geometricServices.forEach(s => s.updateUI({ visible: true }));
  }

}
